module.exports = __webpack_public_path__ + "static/media/net.4a8943d7.svg";